import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import butterflyApi from '../ButterflyApi';
import {
  CATEGORY_LABELS,
  INQUIRY_CATEGORIES,
  INQUIRY_STATUSES,
  STATUS_BADGE_CLASS,
  STATUS_LABELS,
  formatInquiryDate,
  getApiErrorMessage,
  normalizeInquiryList,
} from './supportInquiryUtils';

const ManageInquiryList = () => {
  const navigate = useNavigate();
  const [inquiries, setInquiries] = useState([])
  const [status, setStatus] = useState('')
  const [category, setCategory] = useState('')
  const [supporterNo, setSupporterNo] = useState('')
  const [loading, setLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  const load = useCallback(async () => {
    setLoading(true)
    setErrorMessage('')
    const response = await butterflyApi.getManageInquiries(status, category, supporterNo.trim(), error => {
      setErrorMessage(getApiErrorMessage(error, '문의 목록을 불러오지 못했습니다.'))
    })
    setInquiries(normalizeInquiryList(response))
    setLoading(false)
  }, [status, category, supporterNo])

  useEffect(() => {
    load()
  }, [load])

  return <div className='px-4 py-8'>
    <div className='mb-4'>
      <a href='/manage' className='text-blue-600 underline'>Manage</a>
    </div>
    <div className='text-2xl font-bold'>1:1 문의 관리</div>

    <div className='mt-5 flex flex-wrap items-end gap-3'>
      <label className='block'>
        <span className='block text-xs font-bold text-gray-600'>상태</span>
        <select className='mt-1 rounded border border-gray-300 px-3 py-2 text-sm' value={status} onChange={event => setStatus(event.target.value)}>
          <option value=''>전체</option>
          {INQUIRY_STATUSES.map(item => <option key={item.value} value={item.value}>{item.label}</option>)}
        </select>
      </label>
      <label className='block'>
        <span className='block text-xs font-bold text-gray-600'>카테고리</span>
        <select className='mt-1 rounded border border-gray-300 px-3 py-2 text-sm' value={category} onChange={event => setCategory(event.target.value)}>
          <option value=''>전체</option>
          {INQUIRY_CATEGORIES.map(item => <option key={item.value} value={item.value}>{item.label}</option>)}
        </select>
      </label>
      <label className='block'>
        <span className='block text-xs font-bold text-gray-600'>사용자 번호</span>
        <input
          className='mt-1 rounded border border-gray-300 px-3 py-2 text-sm'
          value={supporterNo}
          onChange={event => setSupporterNo(event.target.value.replace(/[^0-9]/g, ''))}
          placeholder='supporterNo'
        />
      </label>
      <button type='button' className='rounded bg-blue-600 px-4 py-2 text-sm font-bold text-white' onClick={load}>
        조회
      </button>
    </div>

    {loading && <div className='mt-6 text-sm text-gray-500'>로딩중...</div>}
    {errorMessage && <div className='mt-6 rounded border border-red-200 bg-red-50 p-3 text-sm text-red-600'>{errorMessage}</div>}

    <div className='mt-6 overflow-x-auto'>
      <table className='min-w-full border-collapse text-left text-sm'>
        <thead>
          <tr className='border-b bg-gray-50'>
            <th className='px-3 py-3'>No</th>
            <th className='px-3 py-3'>상태</th>
            <th className='px-3 py-3'>카테고리</th>
            <th className='px-3 py-3'>제목</th>
            <th className='px-3 py-3'>사용자</th>
            <th className='px-3 py-3'>주인공</th>
            <th className='px-3 py-3'>접수</th>
            <th className='px-3 py-3'>답변</th>
          </tr>
        </thead>
        <tbody>
          {inquiries.map(inquiry => (
            <tr
              key={inquiry.inquiryNo}
              className='cursor-pointer border-b hover:bg-gray-50'
              onClick={() => navigate(`/manage/inquiries/${inquiry.inquiryNo}`)}
            >
              <td className='px-3 py-3'>{inquiry.inquiryNo}</td>
              <td className='px-3 py-3'>
                <span className={`rounded-full px-2 py-1 text-xs font-bold ${STATUS_BADGE_CLASS[inquiry.status] || 'bg-gray-100 text-gray-500'}`}>
                  {STATUS_LABELS[inquiry.status] || inquiry.status}
                </span>
              </td>
              <td className='px-3 py-3'>{CATEGORY_LABELS[inquiry.category] || inquiry.category}</td>
              <td className='max-w-lg px-3 py-3 font-bold'>{inquiry.title}</td>
              <td className='px-3 py-3'>{inquiry.supporterNo} {inquiry.supporterName}</td>
              <td className='px-3 py-3'>{inquiry.heroNo || '-'} {inquiry.heroName || ''}</td>
              <td className='px-3 py-3 whitespace-nowrap'>{formatInquiryDate(inquiry.registerDatetime)}</td>
              <td className='px-3 py-3 whitespace-nowrap'>{formatInquiryDate(inquiry.answeredDatetime)}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {!loading && inquiries.length === 0 && <div className='border-b px-3 py-8 text-center text-sm text-gray-500'>문의가 없습니다.</div>}
    </div>
  </div>
}

export default ManageInquiryList
